import {
  BarChart3,
  Building2,
  Calendar,
  FileText,
  TrendingUp,
} from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export function InitialScreen() {
  return (
    <div className="flex min-h-[60vh] w-full items-center justify-center px-4 py-10">
      <Card className="w-full max-w-3xl border-2 border-indigo-200/60 bg-white shadow-xl dark:border-indigo-800/40 dark:bg-slate-900">
        <div className="flex flex-col items-center gap-4 px-6 py-8 text-center">
          {/* Compact header */}
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-blue-600 to-indigo-600 text-white shadow-md dark:from-blue-500 dark:to-indigo-500">
              <BarChart3 className="h-6 w-6" />
            </div>
            <div className="text-right">
              <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">
                تقرير الشركات التفصيلي
              </h1>
              <p className="mt-1 text-sm font-medium text-slate-700 dark:text-slate-300">
                اختر الشركة والفترة الزمنية لعرض التقرير التفصيلي
              </p>
            </div>
          </div>

          {/* Highlights */}
          <div className="mt-2 grid w-full grid-cols-2 gap-2 sm:grid-cols-4">
            <Badge
              variant="soft"
              className="justify-center gap-1.5 bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-300"
            >
              <Building2 className="h-3.5 w-3.5" /> الشركات
            </Badge>
            <Badge
              variant="soft"
              className="justify-center gap-1.5 bg-emerald-50 text-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-300"
            >
              <TrendingUp className="h-3.5 w-3.5" /> التحليلات
            </Badge>
            <Badge
              variant="soft"
              className="justify-center gap-1.5 bg-violet-50 text-violet-700 dark:bg-violet-900/20 dark:text-violet-300"
            >
              <FileText className="h-3.5 w-3.5" /> التقارير
            </Badge>
            <Badge
              variant="soft"
              className="justify-center gap-1.5 bg-amber-50 text-amber-700 dark:bg-amber-900/20 dark:text-amber-300"
            >
              <Calendar className="h-3.5 w-3.5" /> الفترات
            </Badge>
          </div>

          {/* Tip row */}
          <div className="mt-4 flex items-center gap-2 rounded-lg border border-indigo-200/60 bg-indigo-50 px-3 py-2 text-sm text-indigo-800 dark:border-indigo-800/40 dark:bg-indigo-950/20 dark:text-indigo-300">
            <span>ابدأ بتحديد الشركة والفترة من أعلى الصفحة.</span>
          </div>
        </div>
      </Card>
    </div>
  );
}
